export function pumpModulationToFlowRate(percentVal: number): number {

	let dataPoints = [
		{ min_in: 0, max_in: 0.2999999999999999, min_out: 0, max_out: 0, mode: 'linear' },
		{ min_in: 0.3, max_in: 0.325, min_out: 0, max_out: 250, mode: 'linear' },
		{ min_in: 0.325, max_in: 0.4, min_out: 250, max_out: 320, mode: 'linear' },
		{ min_in: 0.4, max_in: 0.5, min_out: 320, max_out: 410, mode: 'linear' },
		{ min_in: 0.5, max_in: 0.6, min_out: 410, max_out: 1000, mode: 'exponential' },
		{ min_in: 0.6, max_in: 0.7, min_out: 1000, max_out: 1200, mode: 'linear' },
		{ min_in: 0.7, max_in: 0.8, min_out: 1200, max_out: 1400, mode: 'linear' },
		{ min_in: 0.8, max_in: 0.9, min_out: 1400, max_out: 1700, mode: 'linear' },
		{ min_in: 0.9, max_in: 1, min_out: 1700, max_out: 2100, mode: 'linear' }
	];

	let point = percentVal / 100.0;
	let dataPointsFiltered = dataPoints.filter(x => (x.min_in <= point && x.max_in >= point));
	if (dataPointsFiltered.length == 0) {
		throw "Out of bounds: No dataPoints for value " + point;
	}

	let dp = dataPointsFiltered[0];

	if (dp.max_out == dp.min_out) {
		return dp.max_out;
	}

	let xPerc = (point - dp.min_in) / (dp.max_in - dp.min_in);
	switch (dp.mode) {
		case 'exp':
		case 'exponential': {
			if (dp.min_out == 0) {
				return 1;
			}
			return dp.min_out * Math.pow((dp.max_out / dp.min_out), xPerc);

		}
		case 'linear':
		default: {
			let width = (dp.max_out - dp.min_out)
			return dp.min_out + (xPerc) * width;
		}
	}

}